import { render } from "./UpdateNote.vue?vue&type=template&id=506aeb29&scoped=true"
import script from "./UpdateNote.vue?vue&type=script&lang=js"
export * from "./UpdateNote.vue?vue&type=script&lang=js"

import "./UpdateNote.vue?vue&type=style&index=0&id=506aeb29&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506aeb29"]])

export default __exports__